"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoWrapper = exports.Nav = void 0;
const app_1 = require("@obvio/app");
exports.Nav = app_1.styled.nav `
  height: var(--nav-height);
  position: sticky;
  top: 0;
  z-index: 3;
  width: 100%;
  max-width: inherit;
  border-bottom: 1px solid ${(theme) => theme.stroke};
  background: white;
  display: grid;
  @media ${app_1.mobile} {
    max-width: 100%;
  }
`;
exports.LogoWrapper = (0, app_1.styled)(app_1.Link) `
  ${(theme) => theme.flexCenter};
  padding: ${(theme) => theme.spacing.extraSmall};
  max-width: 100%;
  @media ${app_1.notDesktop} {
    padding: unset;
    padding-left: ${(theme) => theme.spacing.extraSmall};
    grid-area: logo;
    justify-content: unset;
    align-content: center;
    justify-self: start;
  }
`;
